<template>
    <div class="A4 font-c">
        <div class="x_body">
            <div class="print-header">
                <h2 class="text-center font-m" style="font-weight: 600; font-size: 16pt;">{{company.Name}}</h2>
                <p class="text-center">Tel: 095 615 758 / 010 877 420</p>
                <h4 class="text-center" style="font-size: 14pt;">
                    <span class="font-m">វិក្កយបត្រ</span>/INVOICE
                </h4>
            </div>
            <div style="display:flex; margin-bottom: 40px">
                <div style="flex-grow: 1;">
                    <table class="table-print">
                        <tbody>
                            <tr>
                                <th style="width: 220px;">អតិថិជន/Customer Name</th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Name}}</td>
                            </tr>
                            <tr>
                                <th>
                                    អាស័យដ្ឋាន/Address
                                </th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Address}}</td>
                            </tr>
                            <tr>
                                <th>លេខទូរស័ព្ទ/Phone</th>
                                <td class="v-top" style="width: 15px;">:</td>
                                <td class="v-top">{{customer.Phone}}</td>
                            </tr>
                            <tr>
                                <th>អ្នកតំណាងលក់/Saller</th>
                                <td style="width: 15px;">:</td>
                                <td>{{invoice.SaleRep}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div style="flex-grow: 1;">
                    <table class="table-print" align="right">
                        <tbody>
                            <tr>
                                <th style="width: 180px; text-align: right">លេខរៀងវិក្កយបត្រ</th>
                                <td style="width: 15px;">:</td>
                                <td>{{invoice.Num}}</td>
                            </tr>
                            <tr>
                                <th style="width: 120px; text-align: right">កាលបរិច្ឆេទ/Date</th>
                                <td>:</td>
                                <td>{{$format(invoice.Date, 'DD/MM/YYYY')}}</td>
                            </tr>
                            <tr>
                                <th style="width: 120px; text-align: right">Pint Time: </th>
                                <td>:</td>
                                <td>{{$now().format('DD/MM/YYYY HH:mm A')}}</td>
                            </tr>
                            <tr>
                                <th style="width: 120px; text-align: right">PO Order Ref No: </th>
                                <td></td>
                                <td>{{invoice.DocSourceNo}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <table class="table table-bordered table-sm no-bor">
                        <thead>
                            <tr class="text-center">
                                <th class="text-center" style="width: 50px;">ល.រ <br>No</th>
                                <th>បរិយាយ <br> Description of Goods </th>
                                <th style="width: 70px;">ចំនួន <br>Quantity</th>
                                <th style="width: 80px;">ឯកតា <br>Uom</th>
                                <th style="width: 100px;">តម្លៃ <br>Price</th>
                                <th style="width: 120px;">តម្លៃសរុប <br>Net Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret,index) in lines" :key="ret.Id">
                                <td class="text-center">{{index+1}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td class="text-center">{{ret.Quantity}}</td>
                                <td class="text-center">{{ret.UomName}}</td>
                                <td class="text-right">{{$money(ret.Price)}}</td>
                                <td class="text-right">{{$money(ret.SubTotal)}}</td>
                            </tr>
                            <tr>
                                <th colspan="5" class="text-right">សរុប/Grand Total:</th>
                                <th class="text-right">{{$money(invoice.TotalAmount)}}</th>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="footer" style="padding: 20px 50px;">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group" style="display: flex">
                            <label class="control-lable" style="margin-right: 10px">{{ $t('noted') }} / Remark: </label>
                            <div>{{invoice.Description}}</div>
                        </div>
                    </div>
                </div>
                <div style="display: flex; justify-content: space-between; margin-top: 40px">
                    <div class="text-center">
                        <div>ហត្តលេខា​និងឈ្មោះអ្នកលក់</div>
                        <div>Seller's Signature & Name</div>
                    </div>
                    <div class="text-center">
                        <div>ហត្តលេខា​និងឈ្មោះអ្នកដឹកជញ្ជូន</div>
                        <div>Delivery's Signature & Name</div>
                    </div>
                    <div>
                        <div style="margin-left: 20px">ហត្តលេខា​និងឈ្មោះអ្នកទិញ</div>
                        <div style="margin-left: 10px">Customer's Signature & Name</div>
                        <div style="height: 100px;"></div>
                    </div>
                </div>
                <hr/>
                <div class="d-flex" style="gap: 15px;">
                    <img src="/img/QrCode.jpg" alt="ABA KHQR Code" style="width: 180px; height: 180px;" />
                    <article>
                        <div>Scan to pay by ABA Pay</div>
                        <div style="padding: 15px 0;">NAME: <span>HENGTHAVY PHARMA PHARMACY</span></div>
                        <div>ការផ្ទេរប្រាក់ទៅគណនីផ្សេងដែលមិនមែនឈ្មោះខាងលេី​ យេីងខ្ញុំមិនទទួលស្គាល់ឡេីយ</div>
                    </article>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                company: {},
                customer: {},
                invoice: {
                    IsApproved: true
                },
                lines: [],
                rateValue: 0
            }
        },
        created() {
            var id = this.$route.params.id;
            if (id !== undefined && id != null && id !== '') {
                this.findById(id);
            }
            this.getCompany();
        },
        methods: {
            getCompany: function() {
                this.$api().post("company").then(res => {
                    this.company = res.data.Data;
                });
            },
            findById(){
                let id = this.$route.params.id;
                if(id != undefined && id != null && id != ''){
                    let loading = this.$loading.show();
                    this.$api().post('sale/invoice/find', { Id: id }).then(res => {
                        var data = res.data.Data;
                        this.invoice = data.SaleInvoice;
                        this.customer = res.data.Json.Customer;
                        this.lines = data.SaleInvoiceLines;
                    }).finally(function(){ loading.hide(); });
                }
            }
        }
    }
</script>
<style scoped>
    .font-c *{
        font-size: 14pt;
    }
    @media print{
        .font-c *{
            font-size: 16pt;
        }
        .table td,
        .table th{
            border-color: black !important;
        }
    }
</style>
